import { render, staticRenderFns } from "./ResourceLinkAdmin.vue?vue&type=template&id=533ebf38&scoped=true&"
import script from "./ResourceLinkAdmin.vue?vue&type=script&lang=js&"
export * from "./ResourceLinkAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533ebf38",
  null
  
)

export default component.exports